'use strict';

import VirtualProductStatus from "@p1s/p1s-common-react/constants/VirtualProductStatus";
import ProductEnum from "@p1s/p1s-common-react/constants/ProductEnum";

const AvailabilityProductIds = [
    ProductEnum.Quantifi.id,
    ProductEnum.PocAdvisor.id,
    ProductEnum.SepsisMonitor.id,
    ProductEnum.Simplifi.id,
    ProductEnum.MedStorage.id,
    ProductEnum.MedTrays.id,
    ProductEnum.Veriform.id
];

export const getProductAvailabilityInfo = (virtualProducts) => {
    const productAvailableInfos = [];

    const pharmacyProduct = virtualProducts.find(x => x.id == ProductEnum.Pharmacy.id);
    const infectionPrevention = virtualProducts.find(x => x.id == ProductEnum.InfectionPrevention.id);
    const sentri7Availability = pharmacyProduct.status == VirtualProductStatus.active &&
        infectionPrevention.status == VirtualProductStatus.active;
    productAvailableInfos.push({
        id: ProductEnum.Pharmacy.id,
        productName: "Sentri7",
        isAvailable: sentri7Availability
    });

    AvailabilityProductIds.forEach(e => {
        const product = virtualProducts.find(x => x.id == e);
        productAvailableInfos.push({
            id: product.id,
            productName: product.name,
            isAvailable: product.status == VirtualProductStatus.active
        });
    });

    return productAvailableInfos;
};
